<template>
      <div id="rewards">
            <section class="section rewards-hero animate__animated animate__fadeIn">
                  <BackButton link="/total-health" />
                  <div class="grid-container max">
                        <div class="rewards-grid">
                              <div class="rewards-left">
                                    <h1>Rewards for<br />healthy living</h1>
                                    <p class="rewards-subtitle">Reduce your costs by earning points<sup>1</sup></p>
                                    <p class="rewards-desc">With each of the Anthem Plan Options, you and your covered spouse can each <strong>earn up to 480 points</strong> (for a total of <strong>up to 960</strong>) through the <em>Be Well SHBP<sup>&reg;</sup></em> well-being program administered by Sharecare.<sup>1</sup></p>
                                    <p class="rewards-desc">These points can be redeemed as credits and applied to covered medical and pharmacy expenses.</p>
                                    <div class="rewards-card">
                                          <h5>Earning rewards is easy</h5>
                                          <p>Once you complete certain health actions in the <em>Be Well SHBP&reg;</em> well-being program, you will earn points that you can choose to redeem as credits. If redeemed as credits, the credits will be deposited into a spending account tied to your HMO or HRA plan.</p>
                                    </div>
                              </div>
                              <div class="rewards-right">
                                    <div class="rewards-box">
                                          <div class="rewards-item">
                                                <img src="~@/assets/img/chart-icon.svg" alt="" />
                                                <div>
                                                      <h5>Take</h5>
                                                      <p>the RealAge<sup>&reg;</sup> Test<sup>2</sup></p>
                                                </div>
                                          </div>
                                          <div class="rewards-item">
                                                <img src="~@/assets/img/wellbeing-solutions-rewards-icon.svg" alt="" />
                                                <div>
                                                      <h5>Get</h5>
                                                      <p>a biometric screening</p>
                                                </div>
                                          </div>
                                          <div class="rewards-item">
                                                <img src="~@/assets/img/health-connections-rewards-icon.svg" alt="" />
                                                <div>
                                                      <h5>Complete</h5>
                                                      <p>well-being coaching, online challenges, and/or preventive screenings</p>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                        <p class="rewards-footnote">1. Completing your well-being incentive actions with Sharecare will earn you points. You can choose to redeem these points for well-being incentive credits to use on covered medical and pharmacy expenses or the Visa Prepaid Card option. Visit BeWellSHBP.com for more information. 2. Points cannot be awarded until completion of the RealAge Test.</p>
                  </div>
            </section>
            <div class="rewards-btn-wrap">
                  <router-link to="/plan-credits" class="rewards-btn"><span>Next</span></router-link>
            </div>
      </div>
</template>

<script>
      import BackButton from "../components/BackButton"
      export default {
            name: "SHBPRewards",
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            }
      }
</script>

<style lang="scss">
#rewards {
      .rewards-hero {
            background-color: #ffffff;
            margin-top: 68px;
            padding: 120px 0 160px 0;
            position: relative;

            .back-btn {
                  left: 86px;
                  border-color: #1254E8;

                  &::before {
                        background-image: none;
                        background-color: #1254E8;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .rewards-grid {
                  display: flex;
                  flex-wrap: nowrap;
                  align-items: flex-start;
                  justify-content: space-between;
                  gap: 64px;
                  margin-top: 48px;
            }

            .rewards-left {
                  flex: 2 1 560px;
                  max-width: 640px;

                  h1 {
                        color: #1355E9;
                        font-size: clamp(2.75rem, 4.5vw, 4.25rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 24px;
                  }

                  .rewards-subtitle {
                        color: #012E58;
                        font-size: 1.25rem;
                        font-weight: 600;
                        margin-bottom: 20px;
                  }

                  .rewards-desc {
                        color: #3F3A4E;
                        font-size: 1rem;
                        line-height: 1.6;
                        margin-bottom: 20px;

                        strong {
                              color: #12130f;
                              font-weight: 700;
                        }

                        em {
                              font-style: italic;
                        }
                  }
            }

            .rewards-card {
                  background-color: #F4F5F7;
                  padding: 32px;
                  margin-top: 24px;

                  h5 {
                        color: #1355E9;
                        font-weight: 700;
                        font-size: 1.125rem;
                        margin-bottom: 12px;
                  }

                  p {
                        color: #3F3A4E;
                        font-size: 0.9375rem;
                        line-height: 1.6;
                        margin-bottom: 0;
                  }
            }

            .rewards-right {
                  flex: 1 1 340px;
                  max-width: 420px;
            }

            .rewards-box {
                  background-color: #1355E9;
                  padding: 40px;
            }

            .rewards-item {
                  display: flex;
                  align-items: flex-start;
                  gap: 20px;
                  margin-bottom: 32px;

                  &:last-child {
                        margin-bottom: 0;
                  }

                  img {
                        display: block;
                        flex-shrink: 0;
                        width: 40px;
                        height: 40px;
                        object-fit: contain;
                        margin-top: 2px;
                  }

                  h5 {
                        color: #ffffff;
                        font-weight: 700;
                        font-size: 1.125rem;
                        margin-bottom: 2px;
                  }

                  p {
                        color: rgba(255, 255, 255, 0.9);
                        font-size: 0.9375rem;
                        line-height: 1.4;
                        margin-bottom: 0;
                  }
            }

            .rewards-footnote {
                  color: #6b6b6b;
                  font-size: 0.75rem;
                  line-height: 1.6;
                  margin-top: 48px;
                  margin-bottom: 0;
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 140px 24px;

                  .back-btn {
                        left: 2rem;
                  }

                  .rewards-grid {
                        flex-direction: column;
                        gap: 32px;
                        margin-top: 32px;
                  }

                  .rewards-left {
                        max-width: 100%;

                        h1 {
                              font-size: clamp(2rem, 8vw, 3rem) !important;
                        }
                  }

                  .rewards-right {
                        max-width: 100%;
                  }
            }
      }

      .rewards-btn-wrap {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 3;
            background-color: #ffffff;
            box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
            padding: 20px 0;
            text-align: center;
      }

      .rewards-btn {
            display: block;
            background-color: #1355E9;
            color: #ffffff !important;
            font-weight: 700;
            text-transform: uppercase;
            font-size: 1rem;
            padding: 18px 0;
            width: 100%;
            max-width: 330px;
            text-align: center;
            border-radius: 30px;
            border: none;
            cursor: pointer;
            margin: 0 auto;

            &:hover {
                  background-color: #44B8F3;
            }
      }
}
</style>
